import React from "react";

import Nav from 'react-bootstrap/Nav';
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

import Login from './Login';
import Logout from './Logout';
import AddClients from './clients/AddClients';
import ViewClients from './clients/ViewClients';
import AddMachines from './machines/AddMachines';
import ViewMachines from './machines/ViewMachines';
import ViewMachineLogs from "./machines/ViewMachineLogs";
import { useAuth } from "../Context";
import { useEffect } from "react";
import PrivateRoute from "./PrivateRoutes";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

const Routes = () => {
	
	const { isLoggedIn } = useAuth();

	return (
		<BrowserRouter>
			{isLoggedIn ? 
				<Nav fill variant="tabs" defaultActiveKey="/admin/clients/add">
					<Nav.Item>
						<Nav.Link disabled>
							Wall Machine Admin App 
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={Link} eventKey="1" to="/admin/clients/add">
							Add Clients
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={Link} eventKey="2" to="/admin/clients/view">
							View Clients
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={Link} eventKey="3" to="/admin/machines/add">
							Add Machines
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={Link} eventKey="4" to="/admin/machines/view">
							View Machines
						</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link as={Link} eventKey="5" to="/admin/machines/logs">
							View Machine Logs
						</Nav.Link>
					</Nav.Item>
				</Nav>
				:
				<></>
			}
			<Switch>
				<Route path="/admin/login">
					<Login />
				</Route>
				<PrivateRoute path="/admin/clients/add" component={AddClients} />
				<PrivateRoute path="/admin/clients/view" component={ViewClients} />
				<PrivateRoute path="/admin/machines/add" component={AddMachines} />
				<PrivateRoute path="/admin/machines/view" component={ViewMachines} />
				<PrivateRoute path="/admin/machines/logs" component={ViewMachineLogs} />
				<Route path="/admin/logout">
					<Logout />
				</Route>
				<Redirect from="/" to="/admin/login" />
			</Switch>
		</BrowserRouter>
	);
};

export default Routes;